import React from "react";
import PropTypes from "prop-types";
import * as commentType from './commentTypes';
import Markdown from 'markdown-to-jsx';
import * as resolutionProposalActionType from './commentResolutionProposalActionTypes';
import translate from "react-i18next/dist/commonjs/translate";

class CommentButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { action, active, label, loading, onClick, t } = this.props;

        let icon, commentTypeLabel, title;
        switch (action) {
            case resolutionProposalActionType.RECEIVED: {
                title="By this choice, you initiate that you have received the proposed action and that your work on the action of the incident has begun.Used to convey to SOC that you have been aware of the incident, as well as for your own organization that it is being processed. Once you have finished your work, choose one of the options to close the incident."
                icon = 'fa-file-text-o';
                commentTypeLabel = commentType.RESOLUTION_PROPOSAL_RECEIVED;
                break;
            }
            case resolutionProposalActionType.IMPLEMENTED: {
                title="By this choice you accept the proposed action and close the incident.Used directly if you have established that the proposed action has been accepted or after you have worked clearly with the incident and subsequently established that the proposed action has been accepted."
                icon = 'fa-thumbs-o-up';
                commentTypeLabel = commentType.COMMENT_FROM_CUSTOMER;
                break;
            }
            case resolutionProposalActionType.REJECTED: {
                title="By this choice you do not accept the proposed action but still choose to close the incident.Used when you found that the proposed action was not accepted for any reason. For example, you may have taken another type of action."
                icon = 'fa-thumbs-o-down';
                commentTypeLabel = commentType.COMMENT_FROM_CUSTOMER;
                break;
            }
            case resolutionProposalActionType.REQUEST_FOR_INFORMATION: {
                title="This choice initiates a dialogue with SOC.Used when you have received the action proposal from SOC and realize that, either directly or after you have worked with the incident, the action proposal needs to be supplemented or that you have questions about the incident."
                icon = 'fa-info-circle';
                commentTypeLabel = commentType.COMMENT_FROM_CUSTOMER;
                break;
            }
            default: {
                commentTypeLabel = '';
                icon = '';
            }
        }
        if(active) {
            return (
                <div className="proposalReceivedContainer">
                    <div className={`button buttonProposalReceived buttonPrimary`} onClick={() => { onClick(action, commentTypeLabel); }}
                    data-toggle="tooltip" data-placement="top" title={title}>
                        <i className={`buttonIcon fa fa-2x ${!loading ? icon : 'fa-circle-o-notch fa-spin'}`} />
                        <Markdown>{t(label)}</Markdown>
                    </div>
                </div>
            );
        } else {
        return (
            <div className="proposalReceivedContainer">
                <div className={`button buttonProposalReceived buttonProposalReceivedDisabled`}
                data-toggle="tooltip" data-placement="top" title={title}>
                    <i className={`left buttonIcon fa fa-2x ${!loading ? icon : 'fa-circle-o-notch fa-spin'}`} />
                    <Markdown>{t(label)}</Markdown>
                </div>
            </div>        
        );
        }
    }
}

CommentButton.propTypes = {
    action: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default translate("translations")(CommentButton);




// WEBPACK FOOTER //
// ./src/incidents/comments/commentButton.js